<div class="row">
  <div class="col-md-6" *ngFor="let benefit of benefits">
    <fgb-benefit-item
      [benefit]="benefit"
      [disabled]="disabled"
      [numberClaimed]="numberClaimed"
      [claimLimit]="claimLimit"
    ></fgb-benefit-item>
  </div>
</div>
